import {StockTransferData} from "./stock-transfer.data";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class StockTransferEntityModel extends EntityModel<StockTransferData> {
    constructor(injector: Injector) {
        super(injector, StockTransferData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
